import Div from '@/shared/Div';
import React, { Fragment, memo } from 'react';
import Pagination from './Pagination';
import ViewMoreResults from './ViewMoreResults';
import Container from '@/shared/Container';
import ProductListing from './ProductListing';

type PLPProps = {
  isLoading: boolean;
  products: any[];
  resultCount: number;
  page: number;
  viewMoreProduct: () => void;
  renderPLPHeader?: (plpProps?: any) => React.ReactNode;
};

const PLP = (props: PLPProps) => {
  const { isLoading, products, resultCount, page, viewMoreProduct, renderPLPHeader, ...restProps } =
    props;
  return (
    <Fragment>
      {typeof renderPLPHeader === 'function' ? renderPLPHeader(props) : null}
      <Div className="border-t border-co-subtle">
        <Container>
          <ProductListing list={products} isLoading={isLoading} page={page} />
          <Pagination total={resultCount} resultsCount={products?.length} />
          <ViewMoreResults
            show={Boolean(products.length) && products?.length !== resultCount}
            onClick={viewMoreProduct}
            isLoading={isLoading}
            label="View more results"
          />
        </Container>
      </Div>
    </Fragment>
  );
};

export default memo(PLP);
